import PropTypes from 'prop-types';

import SalesOrderAmountSection from '#/modules/crmMgmt/salesOrder/components/SalesOrderAmountSection';
import SalesOrderCommandBar from '#/modules/crmMgmt/salesOrder/components/SalesOrderCommandBar';
import SalesOrderDetailTabs from '#/modules/crmMgmt/salesOrder/components/SalesOrderDetailTabs';
import SalesOrderMainInfoCard from '#/modules/crmMgmt/salesOrder/components/SalesOrderMainInfoCard';
import SalesOrderShippingReadonlySection from '#/modules/crmMgmt/salesOrder/components/SalesOrderShippingReadonlySection';

const SalesOrderBlock = ({ detail, onRefetch, showActions = false }) => (
  <div className="grid grid-cols-1 gap-4 2xl:grid-cols-2">
    <SalesOrderMainInfoCard
      detail={detail}
      actions={
        showActions ? (
          <SalesOrderCommandBar
            key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
            detail={detail}
            onRefetch={onRefetch}
          />
        ) : null
      }
      containerClassName="2xl:col-span-2"
    />
    <SalesOrderAmountSection detail={detail} />
    <SalesOrderShippingReadonlySection detail={detail} />
    <SalesOrderDetailTabs detail={detail} />
  </div>
);

SalesOrderBlock.propTypes = {
  detail: PropTypes.object.isRequired,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default SalesOrderBlock;
